module.exports = __webpack_public_path__ + "img/30-r.4fc519ae.png";